module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.alert.message) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.alert.type
  }, [_vm._v("\n      " + _vm._s(_vm.alert.message) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "cream-name"
    }
  }, [_vm._v("Sorte")]), _vm._v(" "), _c('div', {
    staticClass: "col offset-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cream.name),
      expression: "cream.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "id": "cream-name"
    },
    domProps: {
      "value": (_vm.cream.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cream.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-check col offset-sm-3"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cream.vegan),
      expression: "cream.vegan"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cream.vegan) ? _vm._i(_vm.cream.vegan, null) > -1 : (_vm.cream.vegan)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cream.vegan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.cream.vegan = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cream.vegan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cream.vegan = $$c
        }
      }
    }
  }), _vm._v("\n        Vegan\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-check col offset-sm-3"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cream.lactosefree),
      expression: "cream.lactosefree"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cream.lactosefree) ? _vm._i(_vm.cream.lactosefree, null) > -1 : (_vm.cream.lactosefree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cream.lactosefree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.cream.lactosefree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cream.lactosefree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cream.lactosefree = $$c
        }
      }
    }
  }), _vm._v("\n        Laktosefrei\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-check col offset-sm-3"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cream.glutenfree),
      expression: "cream.glutenfree"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cream.glutenfree) ? _vm._i(_vm.cream.glutenfree, null) > -1 : (_vm.cream.glutenfree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cream.glutenfree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.cream.glutenfree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cream.glutenfree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cream.glutenfree = $$c
        }
      }
    }
  }), _vm._v("\n        Glutenfrei\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "cream-image"
    }
  }, [_vm._v("Bild")]), _vm._v(" "), _c('div', {
    staticClass: "col offset-sm-1"
  }, [(_vm.cream.imagePath) ? _c('div', {
    staticClass: "cream-image"
  }, [_c('img', {
    attrs: {
      "src": ("/" + (_vm.cream.imagePath) + "?" + _vm.cacheBust)
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "required": !_vm.isExisting,
      "id": "cream-image"
    },
    on: {
      "change": _vm.onChangeFile
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col offset-3"
  }, [_c('button', {
    staticClass: "btn btn-primary save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('router-link', {
    staticClass: "back",
    attrs: {
      "to": "/creams"
    }
  }, [_vm._v("Zurück")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col offset-3"
  }, [(_vm.isExisting) ? _c('button', {
    staticClass: "btn btn-secondary delete",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onDelete($event)
      }
    }
  }, [_vm._v("\n        Löschen\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f497a714"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/frontend/components/pages/creams/_form.vue
// module id = 122
// module chunks = 1